export default{ "new4index":[{
    "date": "2020-01",
    "value": "18.60",
    "t": "新四化整体"
  },
  {
    "date": "2020-02",
    "value": "18.26",
    "t": "新四化整体"
  },
  {
    "date": "2020-03",
    "value": "20.75",
    "t": "新四化整体"
  },
  {
    "date": "2020-04",
    "value": "22.08",
    "t": "新四化整体"
  },
  {
    "date": "2020-05",
    "value": "29.12",
    "t": "新四化整体"
  },
  {
    "date": "2020-06",
    "value": "34.23",
    "t": "新四化整体"
  },
  {
    "date": "2020-07",
    "value": "38.34",
    "t": "新四化整体"
  },
  {
    "date": "2020-08",
    "value": "43.71",
    "t": "新四化整体"
  },
  {
    "date": "2020-09",
    "value": "52.15",
    "t": "新四化整体"
  },
  {
    "date": "2020-10",
    "value": "58.94",
    "t": "新四化整体"
  },
  {
    "date": "2020-11",
    "value": "63.90",
    "t": "新四化整体"
  },
  {
    "date": "2020-12",
    "value": "66.12",
    "t": "新四化整体"
  },
  {
    "date": "2020-01",
    "value": "0.65",
    "t": "电动化"
  },
  {
    "date": "2020-02",
    "value": "1.87",
    "t": "电动化"
  },
  {
    "date": "2020-03",
    "value": "1.67",
    "t": "电动化"
  },
  {
    "date": "2020-04",
    "value": "1.35",
    "t": "电动化"
  },
  {
    "date": "2020-05",
    "value": "1.54",
    "t": "电动化"
  },
  {
    "date": "2020-06",
    "value": "1.71",
    "t": "电动化"
  },
  {
    "date": "2020-07",
    "value": "1.99",
    "t": "电动化"
  },
  {
    "date": "2020-08",
    "value": "2.78",
    "t": "电动化"
  },
  {
    "date": "2020-09",
    "value": "3.90",
    "t": "电动化"
  },
  {
    "date": "2020-10",
    "value": "4.72",
    "t": "电动化"
  },
  {
    "date": "2020-11",
    "value": "5.77",
    "t": "电动化"
  },
  {
    "date": "2020-12",
    "value": "6.38",
    "t": "电动化"
  },
  {
    "date": "2020-01",
    "value": "10.29",
    "t": "网联化"
  },
  {
    "date": "2020-02",
    "value": "10.22",
    "t": "网联化"
  },
  {
    "date": "2020-03",
    "value": "11.71",
    "t": "网联化"
  },
  {
    "date": "2020-04",
    "value": "12.37",
    "t": "网联化"
  },
  {
    "date": "2020-05",
    "value": "18.36",
    "t": "网联化"
  },
  {
    "date": "2020-06",
    "value": "23.38",
    "t": "网联化"
  },
  {
    "date": "2020-07",
    "value": "26.84",
    "t": "网联化"
  },
  {
    "date": "2020-08",
    "value": "31.32",
    "t": "网联化"
  },
  {
    "date": "2020-09",
    "value": "38.81",
    "t": "网联化"
  },
  {
    "date": "2020-10",
    "value": "43.25",
    "t": "网联化"
  },
  {
    "date": "2020-11",
    "value": "46.71",
    "t": "网联化"
  },
  {
    "date": "2020-12",
    "value": "46.27",
    "t": "网联化"
  },
  {
    "date": "2020-01",
    "value": "17.83",
    "t": "智能化"
  },
  {
    "date": "2020-02",
    "value": "17.34",
    "t": "智能化"
  },
  {
    "date": "2020-03",
    "value": "20.01",
    "t": "智能化"
  },
  {
    "date": "2020-04",
    "value": "21.33",
    "t": "智能化"
  },
  {
    "date": "2020-05",
    "value": "28.08",
    "t": "智能化"
  },
  {
    "date": "2020-06",
    "value": "32.29",
    "t": "智能化"
  },
  {
    "date": "2020-07",
    "value": "35.29",
    "t": "智能化"
  },
  {
    "date": "2020-08",
    "value": "39.10",
    "t": "智能化"
  },
  {
    "date": "2020-09",
    "value": "45.15",
    "t": "智能化"
  },
  {
    "date": "2020-10",
    "value": "51.46",
    "t": "智能化"
  },
  {
    "date": "2020-11",
    "value": "56.04",
    "t": "智能化"
  },
  {
    "date": "2020-12",
    "value": "58.71",
    "t": "智能化"
  },
  {
    "date": "2021-01",
    "value": "70.30",
    "t": "新四化整体"
  },
  {
    "date": "2021-02",
    "value": "69.21",
    "t": "新四化整体"
  },
  {
    "date": "2021-03",
    "value": "69.62",
    "t": "新四化整体"
  },
  {
    "date": "2021-04",
    "value": "72.68",
    "t": "新四化整体"
  },
  {
    "date": "2021-05",
    "value": "74.10",
    "t": "新四化整体"
  },
  {
    "date": "2021-06",
    "value": "75.51",
    "t": "新四化整体"
  },
  {
    "date": "2021-07",
    "value": "76.33",
    "t": "新四化整体"
  },
  {
    "date": "2021-08",
    "value": "77.82",
    "t": "新四化整体"
  },
  {
    "date": "2021-09",
    "value": "77.81",
    "t": "新四化整体"
  },
  {
    "date": "2021-10",
    "value": "78.61",
    "t": "新四化整体"
  },
  {
    "date": "2021-11",
    "value": "81.54",
    "t": "新四化整体"
  },
  {
    "date": "2021-12",
    "value": "81.27",
    "t": "新四化整体"
  },
  {
    "date": "2021-01",
    "value": "5.62",
    "t": "电动化"
  },
  {
    "date": "2021-02",
    "value": "6.02",
    "t": "电动化"
  },
  {
    "date": "2021-03",
    "value": "7.78",
    "t": "电动化"
  },
  {
    "date": "2021-04",
    "value": "8.52",
    "t": "电动化"
  },
  {
    "date": "2021-05",
    "value": "9.97",
    "t": "电动化"
  },
  {
    "date": "2021-06",
    "value": "13.05",
    "t": "电动化"
  },
  {
    "date": "2021-07",
    "value": "13.17",
    "t": "电动化"
  },
  {
    "date": "2021-08",
    "value": "15.35",
    "t": "电动化"
  },
  {
    "date": "2021-09",
    "value": "19.01",
    "t": "电动化"
  },
  {
    "date": "2021-10",
    "value": "16.71",
    "t": "电动化"
  },
  {
    "date": "2021-11",
    "value": "18.50",
    "t": "电动化"
  },
  {
    "date": "2021-12",
    "value": "19.78",
    "t": "电动化"
  },
  {
    "date": "2021-01",
    "value": "50.61",
    "t": "网联化"
  },
  {
    "date": "2021-02",
    "value": "50.00",
    "t": "网联化"
  },
  {
    "date": "2021-03",
    "value": "49.48",
    "t": "网联化"
  },
  {
    "date": "2021-04",
    "value": "51.85",
    "t": "网联化"
  },
  {
    "date": "2021-05",
    "value": "53.07",
    "t": "网联化"
  },
  {
    "date": "2021-06",
    "value": "55.71",
    "t": "网联化"
  },
  {
    "date": "2021-07",
    "value": "55.33",
    "t": "网联化"
  },
  {
    "date": "2021-08",
    "value": "58.29",
    "t": "网联化"
  },
  {
    "date": "2021-09",
    "value": "59.20",
    "t": "网联化"
  },
  {
    "date": "2021-10",
    "value": "58.92",
    "t": "网联化"
  },
  {
    "date": "2021-11",
    "value": "64.27",
    "t": "网联化"
  },
  {
    "date": "2021-12",
    "value": "63.90",
    "t": "网联化"
  },
  {
    "date": "2021-01",
    "value": "63.88",
    "t": "智能化"
  },
  {
    "date": "2021-02",
    "value": "62.70",
    "t": "智能化"
  },
  {
    "date": "2021-03",
    "value": "62.85",
    "t": "智能化"
  },
  {
    "date": "2021-04",
    "value": "65.13",
    "t": "智能化"
  },
  {
    "date": "2021-05",
    "value": "66.75",
    "t": "智能化"
  },
  {
    "date": "2021-06",
    "value": "67.62",
    "t": "智能化"
  },
  {
    "date": "2021-07",
    "value": "67.95",
    "t": "智能化"
  },
  {
    "date": "2021-08",
    "value": "69.05",
    "t": "智能化"
  },
  {
    "date": "2021-09",
    "value": "69.58",
    "t": "智能化"
  },
  {
    "date": "2021-10",
    "value": "71.03",
    "t": "智能化"
  },
  {
    "date": "2021-11",
    "value": "74.45",
    "t": "智能化"
  },
  {
    "date": "2021-12",
    "value": "73.94",
    "t": "智能化"
  },
  {
    "date": "2022-01",
    "value": "81.99",
    "t": "新四化整体"
  },
  {
    "date": "2022-01",
    "value": "14.65",
    "t": "电动化"
  },
  {
    "date": "2022-01",
    "value": "64.96",
    "t": "网联化"
  },
  {
    "date": "2022-01",
    "value": "75.64",
    "t": "智能化"
  }
]
}